import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "d-flex align-items-center justify-content-end toggle" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-size-12 text-mild mr-2" }, "申請前の写真を表示", -1)

import ToggleButton from "@/components/atoms/button/ToggleButton.vue";
import FormSelectGroup from "@/components/molecules/form/FormSelectGroup.vue";
import QualificationImage from "@/components/molecules/other/QualificationImage.vue";
import UploadImageCautionArea from "@/components/molecules/other/UploadImageCautionArea.vue";
import UploadImageForm from "@/components/organisms/register/UploadImageForm.vue";
import { Qualification } from "@/types/Master";
import { UserQualificationInputValues } from "@/types/qualification/EditableUserQualificationItems";
import { UserQualification } from "@/types/qualification/UserQualification";
import type { PropType } from "vue";
import { computed, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditQualificationForm',
  props: {
  value: {
    type: Object as PropType<UserQualificationInputValues>,
    required: true
  },
  verifiedQualification: {
    type: Object as PropType<UserQualification | null>,
    default: null
  },
  qualificationOptions: {
    type: Array as PropType<Qualification[]>,
    default: () => []
  },
  isCameraActive: {
    type: Boolean,
    default: true
  },
  disabledQualificationId: {
    type: Boolean,
    default: false
  },
  disabledImage: {
    type: Boolean,
    default: false
  },
  disabledText: {
    type: String,
    default: ""
  }
},
  emits: ["input", "update:isCameraActive"],
  setup(__props, { emit: emits }) {

const props = __props;

const cautions = [
  "四隅が写真に収まっている",
  "印字内容が鮮明",
  "関係ないものが写っていない",
  "撮影するのは1枚の資格証のみ"
];





const isShownVerifiedImage = ref<boolean>(false)

const image = computed(() => {
  if (isShownVerifiedImage.value && props.verifiedQualification) {
    return props.verifiedQualification.image;
  }
  return props.value.image
});
const options = computed(() => {
    return [
      "[資格証の全体]が入っていますか？",
      "反射なく、はっきり読み取れますか？"
    ];
});
const isCameraActiveValue = computed({
  get: () => props.isCameraActive,
  set: (v: boolean) => {
    emits("update:isCameraActive", v);
  }
});

function changeImage(image: string) {
  emits("input", {
    ...props.value,
    image
  });
  // 申請前の写真を表示していた場合、変更した画像を表示するためトグルを戻す
  isShownVerifiedImage.value = false;
}
function onToggle() {
  isShownVerifiedImage.value = !isShownVerifiedImage.value;
}

return (_ctx: any,_cache: any) => {
  const _component_ValidationProvider = _resolveComponent("ValidationProvider")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!__props.disabledImage)
      ? (_openBlock(), _createBlock(UploadImageCautionArea, {
          key: 0,
          cautions: cautions,
          class: "mb-4"
        }))
      : _createCommentVNode("", true),
    _createTextVNode(),
    _createVNode(_component_ValidationProvider, {
      name: "資格",
      tag: "div",
      rules: "required",
      vid: "qualification"
    }, {
      default: _withCtx((validationState) => [
        _createVNode(FormSelectGroup, {
          label: "資格種別",
          appLabelText: "必須",
          value: __props.value.qualification,
          options: __props.qualificationOptions,
          "text-field": "name",
          "value-field": "id",
          "validation-state": validationState,
          class: "mb-4",
          disabled: __props.disabledQualificationId
        }, null, 8, ["value", "options", "validation-state", "disabled"])
      ]),
      _: 1
    }),
    _createTextVNode(),
    (__props.verifiedQualification)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createTextVNode(),
            _createVNode(ToggleButton, {
              checked: isShownVerifiedImage.value,
              onClick: onToggle
            }, null, 8, ["checked"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createTextVNode(),
    _createVNode(UploadImageForm, {
      value: image.value,
      photoGraphingType: "qualification",
      appLabelText: "必須",
      appLabelVariant: "red",
      isFrontCamera: false,
      isCameraActive: isCameraActiveValue.value,
      "onUpdate:isCameraActive": _cache[0] || (_cache[0] = ($event: any) => ((isCameraActiveValue).value = $event)),
      options: options.value,
      disabled: __props.disabledImage,
      disabledText: __props.disabledText,
      onInput: changeImage
    }, {
      default: _withCtx(() => [
        _createVNode(QualificationImage, { imageUrl: image.value }, null, 8, ["imageUrl"])
      ], undefined, true),
      _: 1
    }, 8, ["value", "isCameraActive", "options", "disabled", "disabledText"])
  ]))
}
}

})